import { type LucideIcon } from "lucide-react";

interface PageTitleProps {
  icon: LucideIcon;
  title: string;
  description: string;
  actions?: React.ReactNode;
}

export function PageTitle({
  icon: Icon,
  title,
  description,
  actions,
}: PageTitleProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3 min-w-0">
        <div className="flex size-10 min-w-10 items-center justify-center rounded-lg bg-primary text-primary-foreground">
          <Icon className="size-5" />
        </div>
        <div className="min-w-0">
          <h1 className="text-2xl font-bold tracking-tight truncate">
            {title}
          </h1>
          <p className="text-sm text-muted-foreground truncate">
            {description}
          </p>
        </div>
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  );
}
